import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

interface FetchColumnsDataParams {
  chartType: string;
  assetGUID?: string;
}

export const fetchColumnsData = createAsyncThunk(
  'testWellColumns/fetchColumnsData',
  async (arg: string | FetchColumnsDataParams) => {
    try {
      let chartType: string;
      let assetGUID: string | undefined;

      if (typeof arg === 'string') {
        chartType = arg;
      } else {
        chartType = arg.chartType;
        assetGUID = arg.assetGUID;
      }

      let apiEndpoint = `/widgets/${encodeURIComponent(chartType)}`;
      if (assetGUID) {
        apiEndpoint += `?assetGuid=${encodeURIComponent(assetGUID)}`;
      }

      const headers: Record<string, string> = {
        'content-type': 'application/json',
      };
      if (assetGUID) {
        headers['x-api-version'] = '2.0';
      }

      return await api
        .get(apiEndpoint, {
          headers,
        })
        .then(function (response) {
          if (response) {
            return response.data;
          } else {
            return null;
          }
        });
    } catch (error) {
      console.error('Error fetching initial state:', error);
      return [];
    }
  },
);
